import { render } from "./CommentCard.vue?vue&type=template&id=7e1b34bc&scoped=true"
import script from "./CommentCard.vue?vue&type=script&lang=js"
export * from "./CommentCard.vue?vue&type=script&lang=js"

import "./CommentCard.vue?vue&type=style&index=0&id=7e1b34bc&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e1b34bc"]])

export default __exports__